import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StepIndicator } from '../ui/StepIndicator';
import { ProfessionalsStep } from './ProfessionalsStep';
import { ServicesStep } from './ServicesStep';
import { LinkServicesStep } from './LinkServicesStep';
import { AgendaStep } from './AgendaStep';
import './OnboardingWizard.css';

export const OnboardingWizard: React.FC = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);

    const handleStepClick = (step: number) => {
        // Validation logic can restrict returning/advancing, but allowClickAhead=true is requested
        setCurrentStep(step);
    };

    const handleNext = () => {
        setCurrentStep(s => Math.min(s + 1, 4));
    };

    const handleBack = () => {
        setCurrentStep(s => Math.max(s - 1, 1));
    };

    const handleComplete = () => {
        navigate('/scheduling');
    };

    return (
        <div className="onboarding-wizard">
            <div className="wizard-container">
                <div className="text-center mb-4">
                    <h2 className="mb-2">Configuração Inicial</h2>
                    <p className="text-muted">Vamos preparar sua conta para os primeiros agendamentos.</p>
                </div>

                <div className="mb-5">
                    <StepIndicator
                        steps={[
                            { label: 'Profissionais' },
                            { label: 'Serviços' },
                            { label: 'Vincular' },
                            { label: 'Agenda' }
                        ]}
                        currentStep={currentStep}
                        onStepClick={handleStepClick}
                        showLabels={true}
                        completedIcon="checkmark"
                        allowClickAhead={true}
                    />
                </div>

                <div className="step-content glass-effect p-4 border-0">
                    {currentStep === 1 && <ProfessionalsStep onNext={handleNext} />}
                    {currentStep === 2 && <ServicesStep onNext={handleNext} onBack={handleBack} />}
                    {currentStep === 3 && <LinkServicesStep onNext={handleNext} onBack={handleBack} />}
                    {currentStep === 4 && <AgendaStep onComplete={handleComplete} onBack={handleBack} />}
                </div>

                <div className="text-center mt-4">
                    <button className="btn btn-link text-muted" onClick={() => navigate('/scheduling')}>
                        Pular configuração por enquanto
                    </button>
                </div>
            </div>
        </div>
    );
};
